<template>
  <div class="dropdown-menu-item-cnt">
    <div class="dropdown-icon">
      <img :src="icons[item.icon]" alt="Icon" />
    </div>

    <div class="dropdown-cnt">
      <div class="body-md fsemibold">
        <div class="dropdown-title">
          {{ item.title }}
        </div>

        <div class="ext-icon" v-if="item.isExt">
          <img :src="icons.extLinkIcon" alt="External link" />
        </div>

        <div class="new-badge" v-if="item.isNew">
          <div class="new-badge-cnt text-sm">Nouveau</div>
        </div>
      </div>
      <div class="body-sm dropdown-desc">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
import navIconProfile from "../../assets/nav-icon-profile.svg";
import navIconRecruiter from "../../assets/nav-icon-recruter.svg";
import navIconPublish from "../../assets/nav-icon-publish.svg";
import navIconAcademy from "../../assets/nav-icon-academy.svg";
import navIconClub from "../../assets/nav-icon-club.svg";
import navIconBlog from "../../assets/nav-icon-blog.svg";
import navIconGlossary from "../../assets/nav-icon-glossary.svg";
import navIconJobs from "../../assets/nav-icon-jobs.svg";
import extLinkIcon from "../../assets/ext-link.svg";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        navIconProfile,
        navIconRecruiter,
        navIconPublish,
        navIconAcademy,
        navIconClub,
        navIconBlog,
        navIconGlossary,
        navIconJobs,
        extLinkIcon,
      },
    };
  },
};
</script>

<style lang="scss">
.dropdown-menu-item-cnt {

  .dropdown-icon {
    float: left;
    margin-right: 16px;
    width: 24px;
    height: 24px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .dropdown-cnt {
    float: left;
    width: calc(100% - 24px - 16px);

    .ext-icon {
      margin-left: 8px;
      float: right;
    }

    .dropdown-title {
      float: left;
    }

    .new-badge {
      float: left;
      position: relative;
      top: 2px;

      margin-left: 8px;
      padding: 0 12px;

      border-radius: 16px;
      background: $primary25;
      mix-blend-mode: multiply;

      .new-badge-cnt {
        text-align: center;
        color: $primary400;

        font-family: "Inter";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }

    .dropdown-desc {
      clear: both;
      margin-top: 4px;
      width: 260px;
    }
  }
}

</style>